import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FITHGameConfig} from "../FITHGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenLite} from "gsap";

export class FITHReelBackgroundView extends BaseView {
    private _reelBG: PIXI.Sprite;
    private _reelBGGlow: PIXI.Sprite;

    /**
     * @description Entering FS.
     */
    public enterFS(): void {
        this._reelBG.texture = GameResources.getTextures("FS_reel_bg")[0];
    }

    /**
     * @description Exiting FS.
     */
    public exitFS(): void {
        this._reelBG.texture = GameResources.getTextures("reel_bg")[0];
    }

    public showReelBGGlowChestEnhancer(): void {
        this._reelBGGlow.visible = true;
        this._reelBGGlow.alpha = 0;
        TweenLite.to(this._reelBGGlow, 25 / 30, {alpha: 0.5});
        TweenLite.to(this._reelBGGlow, 5 / 30, {alpha: 0, delay: 25 / 30, onComplete: () => this._reelBGGlow.visible = false});
    }

    /**
     * @inheritDoc
     */
    protected initAnimations() {
        super.initAnimations && super.initAnimations();
        StageManager.getLayer(FITHGameConfig.instance.LAYERS.REEL_BACKGROUND.name).addChild(this);

        this.createReelBG();
        this.createReelGlowChestEnhancer();
    }

    /**
     * @description To create the reel background image.
     */
    private createReelBG(): void {
        const centre: number = FITHGameConfig.instance.GAME_HEIGHT / 2,
            yOffset: number = 42;

        this._reelBG = new PIXI.Sprite(GameResources.getTextures("reel_bg")[0]);
        this._reelBG.anchor.set(0.5);
        this._reelBG.scale.set(2);
        this._reelBG.position.set(centre, (centre + yOffset));

        this.addChild(this._reelBG);
    }

    private createReelGlowChestEnhancer(): void {
        const centre: number = FITHGameConfig.instance.GAME_HEIGHT / 2,
            yOffset: number = 100;

        this._reelBGGlow = new PIXI.Sprite(GameResources.getTextures("reel_bg_glow")[0]);
        this._reelBGGlow.visible = false;
        this._reelBGGlow.anchor.set(0.5);
        this._reelBGGlow.scale.set(1.9, 1.6);
        this._reelBGGlow.position.set(centre, (centre + yOffset));

        this.addChild(this._reelBGGlow);
    }
}